import { useSearchParams, Link } from "react-router-dom";

export default function PaymentFailed() {
  const [params] = useSearchParams();
  const projectId = params.get("projectId");

  return (
    <div className="min-h-screen flex items-center justify-center bg-red-50 px-4">
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-lg w-full text-center">
        {/* Error icon */}
        <div className="flex items-center justify-center w-20 h-20 mx-auto mb-6 rounded-full bg-red-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-10 h-10 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-3">
          Payment Failed   
        </h1>
        <p className="text-gray-600 mb-6">
          Unfortunately, your payment for this booking has been failed please try again.
        </p>
      </div>
    </div>
  );
}